import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';
import { observable } from 'mobx';
import { FormControl } from '@material-ui/core';
import { InputLabel } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import { Select } from '@material-ui/core';
import { QuestionType } from '../questionTypes';
import CreateTextQuestion from './CreateTextQuestion';
import CreateMultipleChoiceQuestion from './CreateMultipleChoiceQuestion';
import CreateMultipleColumnQuestion from './CreateMultipleColumnQuestion';

interface Props {
  renderSearch: (showSearch: boolean) => void;
}

type LocalStyles = 'tabArea';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({

  tabArea: {
    paddingTop: theme.spacing.unit * 2,
  }

});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionTab extends React.Component<PropsWithStyle, {}> {

  @observable private questionType: QuestionType = QuestionType.TEXT;

  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(false);
    this.setQuestionType = this.setQuestionType.bind(this);
  }


  public render() {
    return (
      <>
        <FormControl fullWidth={true}>
          <InputLabel htmlFor="question-type">{translation.t('question.questionTypes.this')}</InputLabel>
          <Select
            value={this.questionType.toString()}
            onChange={this.setQuestionType}
            inputProps={{
              name: 'question-type',
              id: 'question-type',
            }}
          >
            <MenuItem
              value={QuestionType.TEXT}>{translation.t('question.questionTypes.' + QuestionType.TEXT)}</MenuItem>
            <MenuItem
              value={QuestionType.MULTIPLE_COLUMNS}>{translation.t('question.questionTypes.' + QuestionType.MULTIPLE_COLUMNS)}</MenuItem>
            <MenuItem
              value={QuestionType.MULTIPLE_CHOICE}>{translation.t('question.questionTypes.' + QuestionType.MULTIPLE_CHOICE)}</MenuItem>
          </Select>
        </FormControl>
        <div className={this.props.classes.tabArea}>
          {this.questionType === QuestionType.TEXT &&
          <CreateTextQuestion renderSearch={this.props.renderSearch}/>
          }
          {this.questionType === QuestionType.MULTIPLE_CHOICE &&
          <CreateMultipleChoiceQuestion renderSearch={this.props.renderSearch}/>
          }
          {this.questionType === QuestionType.MULTIPLE_COLUMNS &&
          <CreateMultipleColumnQuestion renderSearch={this.props.renderSearch}/>
          }
        </div>

      </>

    );
  }

  private setQuestionType(event: any) {
    const type = event.target.value;
    if (QuestionType.MULTIPLE_CHOICE.toString() === type) {
      this.questionType = QuestionType.MULTIPLE_CHOICE
    }
    else if (QuestionType.MULTIPLE_COLUMNS.toString() === type) {
      this.questionType = QuestionType.MULTIPLE_COLUMNS
    }
    else {
      this.questionType = QuestionType.TEXT
    }
  }
}

export default withStyles(localStyles)(QuestionTab);
